import * as constants from '../constants'

export const DEFAULT_STATE = {
  loginName: null,
  email: null,
  firstName: null,
  lastName: null,
  thumbnailPhoto: null,
  token: null
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case constants.GET_USER.FULFILLED:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
